"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportOrderExcel = exports.exportAllOrderApi = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _utils = require("@/utils");
var _date = require("@/utils/date");
var _enum = require("@/utils/enum");
var Excel = _interopRequireWildcard(require("exceljs"));
var _fileSaver = require("file-saver");
// import { excludesFontStyleName, fontStyleName } from "@/utils/excel";

var exportOrderExcel = exports.exportOrderExcel = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(_ref) {
    var orders, type, fileName, workbook, worksheet, fontRedBold, cellStyle, styleCell, columnTable, headerRow, columns, data, startRow, buffer, fileType, fileExtension, blob;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          orders = _ref.orders, type = _ref.type;
          console.log("orders", orders);
          fileName = "Danh s\xE1ch \u0111\u01A1n h\xE0ng ".concat(type);
          workbook = new Excel.Workbook();
          worksheet = workbook.addWorksheet("\u0110\u01A1n h\xE0ng ".concat(type), {
            pageSetup: {
              fitToPage: true,
              fitToHeight: 5,
              fitToWidth: 7
            }
          });
          fontRedBold = {
            bold: true,
            size: 11,
            color: {
              argb: "ffff0202"
            }
          }; // style cell
          cellStyle = {
            border: {
              top: {
                style: "thin",
                color: {
                  argb: "#000"
                }
              },
              left: {
                style: "thin",
                color: {
                  argb: "#000"
                }
              },
              bottom: {
                style: "thin",
                color: {
                  argb: "#000"
                }
              },
              right: {
                style: "thin",
                color: {
                  argb: "#000"
                }
              }
            }
          };
          styleCell = {
            primaryCell: {
              font: {
                size: 12
              },
              border: cellStyle.border,
              alignment: {
                vertical: "middle",
                wrapText: true
              }
            },
            subCell: {
              font: {
                bold: true,
                color: {
                  argb: "ff427c27"
                },
                size: 10
              },
              border: cellStyle.border,
              alignment: {
                horizontal: "center",
                vertical: "middle"
              }
            },
            boldCell: {
              font: {
                bold: true,
                size: 14
              },
              border: cellStyle.border,
              alignment: {
                horizontal: "center",
                vertical: "middle",
                wrapText: true
              },
              fill: {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                  argb: "ffff01"
                },
                bgColor: {
                  argb: "ffff01"
                }
              }
            }
          }; //add table
          columnTable = [{
            label: "Tên shipper",
            style: styleCell.boldCell,
            width: 20,
            prop: "name"
          }, {
            label: type == _enum.ORDER_TYPE.FOOD ? "Tên quán" : "Tên khách hàng",
            style: styleCell.boldCell,
            width: 20,
            prop: "customerName"
          }, {
            label: "Số tiền chiết khấu tài xế",
            style: styleCell.boldCell,
            width: 20,
            prop: "moneyIncome",
            numFmt: "#,##0"
          }, {
            label: "Số tiền lợi nhuận",
            style: styleCell.boldCell,
            width: 20,
            prop: "income",
            numFmt: "#,##0"
          }, {
            label: "Thời gian",
            style: styleCell.boldCell,
            width: 20,
            prop: "dateCreated"
          }];
          headerRow = worksheet.getRow(2);
          headerRow.values = columnTable.map(function (e) {
            return e.label;
          });
          headerRow.height = 50;
          headerRow.eachCell(function (cell, colNum) {
            // cell.value = columnTable[colNum - 1].label;
            cell.style = columnTable[colNum - 1].style;
          });
          columns = worksheet.columns;
          columns.forEach(function (col, i) {
            col.width = columnTable[i].width;
          });

          //generate data
          data = orders.map(function (e, index) {
            e.income = e.moneyDistance - e.moneyIncome;
            e.name = e.driver ? e.driver.name : "";
            e.customerName = e.customer ? e.customer.name : "";
            if (type == _enum.ORDER_TYPE.FOOD) {
              e.customerName = e.store ? e.store.name : "";
            }
            e.dateCreated = (0, _date.formatDateTime)(e.dateCreated, "HH:mm, DD/MM/YYYY");
            var tmp = [];
            columnTable.forEach(function (col) {
              var value = (0, _utils.generateProp)(e, col.prop);
              var style = styleCell.primaryCell;
              tmp.push({
                value: value,
                style: style,
                numFmt: col.numFmt
              });
            });
            return tmp;
          });
          startRow = 3;
          data.forEach(function (element) {
            var row = worksheet.getRow(startRow++);
            row.values = element.map(function (e) {
              return e.value;
            });
            row.eachCell(function (cell, index) {
              var col = element[index - 1];
              // @ts-ignore
              cell.style = col.style;
              col.numFmt && (cell.numFmt = col.numFmt);
            });
          });
          _context.next = 20;
          return workbook.xlsx.writeBuffer();
        case 20:
          buffer = _context.sent;
          fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          fileExtension = ".xlsx";
          blob = new Blob([buffer], {
            type: fileType
          });
          (0, _fileSaver.saveAs)(blob, fileName + fileExtension);
        case 25:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function exportOrderExcel(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var exportAllOrderApi = exports.exportAllOrderApi = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(api, query) {
    var maxValue, data, newQuery, res, remaining;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          maxValue = 5000;
          data = [];
          newQuery = (0, _objectSpread2.default)({}, query);
        case 3:
          if (!(data.length < maxValue)) {
            _context2.next = 15;
            break;
          }
          _context2.next = 6;
          return api.findAll(newQuery);
        case 6:
          res = _context2.sent;
          data.push.apply(data, (0, _toConsumableArray2.default)(res.data.data));
          if (!(res.data.data.length == 0)) {
            _context2.next = 10;
            break;
          }
          return _context2.abrupt("break", 15);
        case 10:
          newQuery.page++;
          remaining = maxValue - data.length;
          if (remaining < 500 && remaining > 0) {
            newQuery.limit = remaining;
          }
          _context2.next = 3;
          break;
        case 15:
          return _context2.abrupt("return", data);
        case 16:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function exportAllOrderApi(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();